module.exports = __webpack_public_path__ + "img/Cement-Kiln-Graphic.6b241039.gif";